import * as React from 'react';
import { useSelector } from 'react-redux';

import { PromoCompilationItemLayout, PromoCompilationsLayout } from '../../../../components/PromoCompilation';
import { selectCompilations } from '../../../../selectors/promosPage';
import { PromoCompilationItemContainer } from '../PromoCompilationItem';

export const PromoCompilationsContainer: React.FC = () => {
  const compilations = useSelector(selectCompilations);

  if (compilations.length === 0) {
    return null;
  }

  return (
    <PromoCompilationsLayout>
      {compilations.map((compilation, index) => (
        <PromoCompilationItemLayout key={index}>
          <PromoCompilationItemContainer compilation={compilation} />
        </PromoCompilationItemLayout>
      ))}
    </PromoCompilationsLayout>
  );
};
